'use client';

import { useEffect, useState } from 'react';
import Button from '@/ui/components/Button/Button';
import RouteUnavailableFallback from '@/ui/components/RouteUnavailableFallback/RouteUnavailableFallback';
import Typography from '@/ui/components/Typography/Typography';

import '@/styles/global.scss';
import $ from './error.module.scss';

const UNIFORM_ROUTE_UNAVAILABLE = 'UniformRouteUnavailableError';
const UNIFORM_CIRCUIT_OPEN = 'UniformCircuitOpenError';

function isUniformRouteUnavailable(error: Error): boolean {
  return (
    error.name === UNIFORM_ROUTE_UNAVAILABLE ||
    error.name === UNIFORM_CIRCUIT_OPEN
  );
}

function localeFromPathname(pathname: string): string {
  const segment = pathname.split('/').filter(Boolean)[0];
  return segment ?? 'en-nl';
}

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const [locale, setLocale] = useState('en-nl');

  useEffect(() => {
    setLocale(localeFromPathname(window.location.pathname));
  }, []);

  useEffect(() => {
    if (isUniformRouteUnavailable(error)) {
      console.error(
        JSON.stringify({
          code: 'UNIFORM_ROUTE_UNAVAILABLE',
          locale,
          message: error.message,
        }),
      );
      return;
    }

    console.error(error);
  }, [error, locale]);

  if (isUniformRouteUnavailable(error)) {
    return (
      <div className={$.container}>
        <RouteUnavailableFallback locale={locale} onRetry={reset} />
      </div>
    );
  }

  return (
    <div className={$.container}>
      <Typography variant="h2">Something went wrong</Typography>
      <Typography variant="bodyMedium">
        An unexpected error occurred. Please try again or contact support if the
        problem persists.
      </Typography>
      <Button onClick={reset}>Try again</Button>
    </div>
  );
}
